import React, { useState } from 'react';
import './About.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function About({ userName, onClose }) {
  const [feedback, setFeedback] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setError('');
    setSuccess('');
    if (!feedback.trim()) {
      setError('Please enter your feedback.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ feedbackDesc: feedback, userName }),
      });
      if (!res.ok) throw new Error('Failed to send feedback');
      setSuccess('Thank you for your feedback!');
      setFeedback('');
    } catch (err) {
      setError('Failed to send feedback. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="about-modal-overlay">
      <div className="about-modal" style={{ maxWidth: 340, minWidth: 220, width: '90vw' }}>
        <button className="about-close-btn" onClick={onClose} title="Close">&times;</button>
        <h2>Trip Planner {process.env.REACT_APP_TRIP_PLANNER_VERSION}</h2>
        
        <textarea
          className="about-textarea"
          rows={6}
          placeholder="Share your thoughts, suggestions, or issues..."
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
          style={{ maxWidth: 300, margin: '0 auto', display: 'block' }}
        />
        <button className="about-send-btn" onClick={handleSend} disabled={loading}>
          {loading ? 'Sending...' : 'Send'}
        </button>
        {error && <div className="about-error">{error}</div>}
        {success && <div className="about-success">{success}</div>}
      </div>
    </div>
  );
}
